import * as React from "react"
//import "../styles/stripes.css"


export function Stripes() {
    return <div className="stripes">
        <div className="three">&nbsp;</div>
        <div className="one">&nbsp;</div>
        <div className="two">&nbsp;</div>
    </div>
}